import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaBars, FaHome, FaChartLine, FaExclamationTriangle, FaCog, FaInfo } from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ expanded, toggleSidebar }) => {
  const menuItems = [
    { path: '/', icon: <FaHome />, label: 'Home' },
    { path: '/analysis', icon: <FaChartLine />, label: 'Analyse' },
    { path: '/warnings', icon: <FaExclamationTriangle />, label: 'Warnungen' },
    { path: '/settings', icon: <FaCog />, label: 'Einstellungen' },
    { path: '/info', icon: <FaInfo />, label: 'Info' }
  ];

  return (
    <div className={`sidebar ${expanded ? 'expanded' : ''}`}>
      <div className="sidebar-header">
        <button className="menu-toggle" onClick={toggleSidebar}>
          <FaBars />
        </button>
        {expanded && <span className="sidebar-title">LEONIK</span>}
      </div>

      <div className="sidebar-divider"></div>

      <nav className="sidebar-nav">
        {menuItems.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            title={!expanded ? item.label : ''}
          >
            <span className="nav-icon">{item.icon}</span>
            {expanded && <span className="nav-label">{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        {expanded && (
          <div className="footer-text">
            <p>Cristal Vision</p>
            <p className="version">v1.0.0</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
